module.exports = __webpack_public_path__ + "static/maan-0e7175e73ff2ac6ec38c991d29a671b2.png";